import { render, staticRenderFns } from "./conversation-list-item.vue?vue&type=template&id=0a49ecc8&scoped=true"
import script from "./conversation-list-item.vue?vue&type=script&lang=js"
export * from "./conversation-list-item.vue?vue&type=script&lang=js"
import style0 from "./conversation-list-item.vue?vue&type=style&index=0&id=0a49ecc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a49ecc8",
  null
  
)

export default component.exports